import { Button, DropdownButton } from "../toolbar-buttons";
import style from "./arrow-head-picker.module.css";
import { ArrowHeadType, getArrowheadIconRenderer } from "frontend/canvas-designer-new/elements/connector/arrow-heads";
import classNames from "classnames";
import IconBase from "frontend/icons/icon-base";

export function ArrowheadPicker({
  value,
  onChange,
}: {
  value?: [string, string];
  onChange: (arrowHeads: [string, string], addUndo: boolean) => void;
}) {
  function renderSwapIcon() {
    return (
      <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.007 5.80799L10.8819 5.31856C10.6152 4.27467 10.0255 3.35036 9.20681 2.68663C8.38842 2.02315 7.38695 1.65684 6.3573 1.64024C5.32778 1.62364 4.3232 1.95745 3.49787 2.59245C2.82601 3.10937 2.49917 3.61241 2.10295 4.42862L3.98329 4.20818L4.10093 5.21161L0.53894 5.62919L0.110726 1.97646L1.11416 1.85883L1.33131 3.71117C1.71286 2.96798 2.12479 2.37415 2.8818 1.79172C3.88652 1.0187 5.11359 0.609753 6.37359 0.63007C7.63344 0.650385 8.8523 1.09862 9.84305 1.90184C10.8335 2.7048 11.5413 3.81798 11.8608 5.0685L11.9858 5.55793L11.007 5.80799Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.33042 6.65039L1.39762 7.15105C1.54094 8.21889 2.01905 9.20558 2.75489 9.96012C3.49047 10.7144 4.44247 11.1948 5.46319 11.3312C6.48376 11.4675 7.52039 11.253 8.41404 10.7184C9.14151 10.2832 9.5247 9.82163 10.0133 9.05712L8.12004 9.05712L8.12004 8.04682L11.7064 8.04682L11.7064 11.7246L10.6961 11.7246L10.6961 9.85953C10.2306 10.5532 9.75236 11.0951 8.93268 11.5854C7.84479 12.2362 6.57845 12.4995 5.32939 12.3326C4.08047 12.1657 2.92209 11.5786 2.0316 10.6655C1.14139 9.75267 0.567981 8.56465 0.396296 7.28544L0.329102 6.78478L1.33042 6.65039Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  function renderNoneIcon() {
    return <span className={style.noneIcon}>None</span>;
  }

  function renderPopup(index: number) {
    const allowedArowHeads: ArrowHeadType[] = [
      "none",
      "arrow",
      "long-arrow",
      "filled-long-arrow",
      "wide-arrow",
      "filled-wide-arrow",
      "rounded-arrow",
      "filled-rounded-arrow",
    ];

    return (
      <div className={style.popupContainer}>
        <div className={style.arrowHeadGrid}>
          {allowedArowHeads.map((arrowHead) => (
            <Button
              key={arrowHead}
              className={classNames(style.arrowHeadButton, {
                [style.selected]: value?.[index] === arrowHead,
              })}
              onClick={() => {
                const newValue = ["keep", "keep"];
                newValue[index] = arrowHead;
                onChange(newValue as [string, string], true);
              }}
            >
              {arrowHead === "none" ? (
                renderNoneIcon()
              ) : (
                <div className={style.arrowIcon}>
                  <IconBase
                    width={36}
                    height={24}
                    strokeLinecap="round"
                    strokeWidth={1.2}
                    viewBox="3 -5 22 17"
                    renderPath={getArrowheadIconRenderer(arrowHead ?? "none")}
                  />
                </div>
              )}
            </Button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={style.layout}>
      <DropdownButton renderPopup={() => renderPopup(1)} hideArrow>
        {(value?.[1] ?? "none") === "none" ? (
          renderNoneIcon()
        ) : (
          <div className={style.arrowIconFlipped}>
            <IconBase
              width={32}
              height={24}
              strokeLinecap="round"
              strokeWidth={1.2}
              viewBox="1 -4 22 17"
              renderPath={getArrowheadIconRenderer((value?.[1] as ArrowHeadType) ?? "none")}
            />
          </div>
        )}
      </DropdownButton>
      <Button
        className={style.swapButton}
        onClick={() => onChange && onChange([value?.[1] ?? "none", value?.[0] ?? "none"], true)}
      >
        <IconBase width={18} height={18} viewBox="0 0 12 13" renderPath={renderSwapIcon} />
      </Button>
      <DropdownButton renderPopup={() => renderPopup(0)} hideArrow>
        {(value?.[0] ?? "none") === "none" ? (
          renderNoneIcon()
        ) : (
          <IconBase
            width={32}
            height={24}
            strokeLinecap="round"
            strokeWidth={1.2}
            viewBox="1 -4 22 17"
            renderPath={getArrowheadIconRenderer((value?.[0] as ArrowHeadType) ?? "none")}
          />
        )}
      </DropdownButton>
    </div>
  );
}
